import { ROLES } from '@/auth/enums/auth.enum';

export const COURSE_TEMPLATES_API = {
  CREATE_COURSE_TEMPLATE: 'course/template/upload',
  CREATE_TEMPLATE_FROM_COURSE: 'course/template/{sourceContentId}/{templateScope} ',
  GET_COURSE_TEMPLATES: 'course/template/?page={page}&pageSize={pageSize}',
  CREATE_COURSE_FROM_TEMPLATE: 'course/template/{courseTemplateId}/copy',
  GET_GRADE_LEVELS: 'curriculum/{organizationId}/gradelevel',
  GET_COURSE_TEMPLATE: 'course/template/{templateId}',
  UPDATE_COURSE_TEMPLATE: 'course/template/upload/{templateId}',
  GET_SCHOOL_CALENDAR_OPT: 'schoolday',
  GET_MY_COURSE_TEMPLATES: 'course/template/myTemplates',
  PUBLISH_COURSE_TEMPLATE: 'course/template/{templateId}/publish/{templateScope}',
  BUY_COURSE_TEMPLATE: 'course/template/{templateId}/buy',
  GET_TEMPLATE_INFO: 'content/course/{templateId}',
  GET_CONTENT_BY_EDITOR: 'content/{templateId}/structure/textByEditor',
  REMOVE_COURSE_TEMPLATE: 'course/template/{templateId}',
  LOCK_UNLOCK_TEMPLATE: 'course/template/{templateId}/lock',
  SHARE_UNSHARE_TEMPLATE: 'course/template/{templateId}/share/{personId}',
  UPDATE_OWNER_TEMPLATE: 'course/template/{templateId}/owner/{personId}',
  GET_QUICK_SUBJECT_INFO: 'content/quickContent/{id}',
  COPY_TO_SUBJECT: 'course/template/{templateId}/copy?sync={sync}',
  GET_COURSE_TEMPLATES_STRUCTURE_BY_IDS: 'course/template/templateStructureByIds?templateIds={templateIds}',
};

export const MENU_TEMPLATE_IDS = {
  VIEW: 'VIEW',
  DOWNLOAD: 'DOWNLOAD',
  REMOVE: 'REMOVE',
  EDIT_CONTENT: 'EDIT_CONTENT',
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  MAKE_TEMPLATE: 'MAKE_TEMPLATE',
  MAKE_SUBJECT: 'MAKE_SUBJECT',
  TEMPLATE_ADMIN: 'TEMPLATE_ADMIN',
  GET_SUBJECT: 'GET_SUBJECT',
  GET_TEMPLATE: 'GET_TEMPLATE',
  PUBLISH: 'PUBLISH',
  PURCHASED: 'PURCHASED',
  SHARED_WITH_ME: 'SHARED_WITH_ME',
  OWNER:'OWNER',
  BUILD_SUBJECT: 'BUILD_SUBJECT',
  SUBJECT_BUILDER: 'SUBJECT_BUILDER'
}

export const COURSE_TEMPLATE_ITEM_MENU = [{
  id: MENU_TEMPLATE_IDS.GET_TEMPLATE,
  text: 'courseTemplates.itemMenu.getTemplate',
}];

export const COURSE_TEMPLATE_PURCHASE_MENU = [{
  id: MENU_TEMPLATE_IDS.PURCHASED,
  text: 'courseTemplates.itemMenu.purchased'
}];

export const COURSE_TEMPLATE_OWNER_MENU = [{
  id: MENU_TEMPLATE_IDS.OWNER,
  text: 'courseTemplates.itemMenu.owner'
}];

export const COURSE_TEMPLATE_SHARED_WITH_MENU = [{
  id: MENU_TEMPLATE_IDS.SHARED_WITH_ME,
  text: 'courseTemplates.itemMenu.sharedWithMe'
}];

export const COURSE_TEMPLATE_ITEM_PURCHASED_MENU = [{
  id: MENU_TEMPLATE_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.MAKE_SUBJECT,
  text: 'myContent.itemMenu.copyToSubject',
  borderBottom: true,
},
/*{
  id: MENU_TEMPLATE_IDS.GET_SUBJECT,
  text: 'myContent.itemMenu.subjectBuilder',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},*/
{
  id: MENU_TEMPLATE_IDS.BUILD_SUBJECT,
  text: 'myContent.itemMenu.buildSubject',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},
{
  id: MENU_TEMPLATE_IDS.TEMPLATE_ADMIN,
  text: 'myContent.itemMenu.templateAdmin',
  borderBottom: true
},
{
  id: MENU_TEMPLATE_IDS.SUBJECT_BUILDER,
  text: 'myContent.itemMenu.subjectBuilderV2',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
}];

export const COURSE_TEMPLATE_ITEM_EDITION_MENU = [{
  id: MENU_TEMPLATE_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.EDIT_CONTENT,
  text: 'myContent.itemMenu.editContent',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.EDIT_PRODUCT,
  text: 'myContent.itemMenu.editDescription',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.MAKE_SUBJECT,
  text: 'myContent.itemMenu.copyToSubject',
  borderBottom: true,
},
/*{
  id: MENU_TEMPLATE_IDS.GET_SUBJECT,
  text: 'myContent.itemMenu.subjectBuilder',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},*/
{
  id: MENU_TEMPLATE_IDS.BUILD_SUBJECT,
  text: 'myContent.itemMenu.buildSubject',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},
{
  id: MENU_TEMPLATE_IDS.TEMPLATE_ADMIN,
  text: 'myContent.itemMenu.templateAdmin',
  borderBottom: true
},
{
  id: MENU_TEMPLATE_IDS.REMOVE,
  text: 'myContent.itemMenu.remove',
  borderBottom: true
},
{
  id: MENU_TEMPLATE_IDS.SUBJECT_BUILDER,
  text: 'myContent.itemMenu.subjectBuilderV2',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},];

export const COURSE_TEMPLATE_SHARED_WITH_SECTION_MENU = [{
  id: MENU_TEMPLATE_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.EDIT_CONTENT,
  text: 'myContent.itemMenu.editContent',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.EDIT_PRODUCT,
  text: 'myContent.itemMenu.editDescription',
  borderBottom: true,
},
{
  id: MENU_TEMPLATE_IDS.MAKE_SUBJECT,
  text: 'myContent.itemMenu.copyToSubject',
  borderBottom: true,
},
/*{
  id: MENU_TEMPLATE_IDS.GET_SUBJECT,
  text: 'myContent.itemMenu.subjectBuilder',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},*/
{
  id: MENU_TEMPLATE_IDS.BUILD_SUBJECT,
  text: 'myContent.itemMenu.buildSubject',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},
{
  id: MENU_TEMPLATE_IDS.TEMPLATE_ADMIN,
  text: 'myContent.itemMenu.templateAdmin',
  borderBottom: true
},
{
  id: MENU_TEMPLATE_IDS.SUBJECT_BUILDER,
  text: 'myContent.itemMenu.subjectBuilderV2',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_AUTHOR]
},];

export const MY_COURSE_TEMPLATE_ITEM_MENU = [{
  id: MENU_TEMPLATE_IDS.PUBLISH,
  text: 'courseTemplates.itemMenu.publish',
  borderBottom: true,
  hideForRoles: [ROLES.EDUAC_TEACHER]
}];

export const COURSE_TEMPLATE_EVENTS = {
  SAVE_COURSE_FORM: 'SAVE_COURSE_FORM',
  SAVE_SYNC_BUILDER_FORM: 'SAVE_SYNC_BUILDER_FORM'
}

export enum PRODUCT_TYPES {
  TEMPLATE = 'TEMPLATE',
  SUBJECT = 'SUBJECT',
  BUILDER = 'BUILDER',
  BUILD = 'BUILD'
}

export const TEMPLATE_SCOPE = {
  PUBLIC: 'PUBLIC',
  ORGANIZATION: 'ORGANIZATION',
  OWNER: 'OWNER'
}

export const AUTOMATIC_FOLDER_BUILDER = {
  NO_AUTOMATIC: 'NO_AUTOMATIC',
  AUTOMATIC_WEEK: 'AUTOMATIC_WEEK',
  AUTOMATIC_MONTH: 'AUTOMATIC_MONTH'
}

export const PURCHASE_TYPES = { 
  OWNER: 'OWNER',
  SHARED_WITH: 'SHARED_WITH',
  PURCHASE: 'PURCHASE',
  BY_CLASS: 'BY_CLASS'
}

export const EDUPAD_API = {
  RESTORE_VERSION: 'api/documents/{collection}/{documentId}/versions/{versionNumber}/restore',
  GET_VERSIONS: 'api/documents/{collection}/{documentId}/versions',
  GET_LATEST: 'api/documents/{collection}/{documentId}/latest',
  GET_VERSION: 'api/documents/{collection}/{documentId}/versions/{versionNumber}',
};
